import { render, staticRenderFns } from "./t-offer-description.vue?vue&type=template&id=7d636a75"
import script from "./t-offer-description.vue?vue&type=script&lang=js"
export * from "./t-offer-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports